import React from "react";
import { filterStyle, filterWrapperStyle } from "../../src/Components/admin/styles/filterStyles"

const CommonFilters = ({
  // User / Login
  UserRole,
  t = (key) => key,

  // Data Type
  showDataType = false,
  typeofData = "",
  settypeofData,

  // Work Order Type
  showWorkOrderType = false,
  selectedWorkType = "",
  setSelectedWorkType,

  // District
  showDistrict = false,
  SelectedDistrict = [],
  AllDistrict = [],
  openDistrict = false,
  setOpenDistrict,
  isAllSelected = false,
  toggleAllDistricts,
  handleDistrictToggle,

  // Taluka
  showTaluka = false,
  SelectedTaluka = "",
  setSelectedTaluka,
  TalukasofDistrict = [],

  // Status
  showStatus = false,
  statusofData = "",
  setstatusofData,

  showHeadCode = false,
  selectedHeadCode = "",
  setSelectedHeadCode,
  headCodeOptions = [],

// Department
showDepartment = false,
selectedDepartment = "",
setSelectedDepartment,

  // Year
  showYear = false,
  selectedYear = "",
  setSelectedYear,
  yearOptions = [],

  // Search
  showSearch = true,
  searchTerm = "",
  setSearchTerm,
}) => {
  // -----------------------------------------
  // CONSOLIDATED DISTRICTS
  // पुणे, पुणे-उत्तर, पुणे-दक्षिण
  // => पुणे
  // -----------------------------------------
  const allDistricts = [
    ...new Set(
      AllDistrict?.map((d) => {
        const district = d?.District_Marathi || "";
        return district.split("-")[0]?.trim();
      }).filter(Boolean)
    ),
  ].sort();


  // -----------------------------------------
  // UNIQUE TALUKAS (each name shown only once)
  // -----------------------------------------
  const uniqueTalukas = [
    ...new Set(
      (TalukasofDistrict || [])
        .map((val) =>
          String(
            typeof val === "string"
              ? val
              : val?.ULBNameMarathi || val?.ulb || val?.Taluka || ""
          ).trim()
        )
        .filter(Boolean)
    ),
  ].sort((a, b) => a.localeCompare(b, "mr"));

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        flexWrap: "nowrap",
      }}
    >
      {/* ================= DATA TYPE ================= */}
      {showDataType && (
        <div style={filterWrapperStyle}>
          <select
            value={typeofData}
            onChange={(e) => settypeofData(e.target.value)}
            style={filterStyle}
          >
            <option value="">Choose Data</option>

            <option value="District">
              3054-2419(Roads and bridge repair maintenance program)
            </option>

            <option value="State">
              2515-1238(MLA Representative)
            </option>
          </select>
        </div>
      )}

      {/* ================= DEPARTMENT ================= */}
      {showDepartment && (
        <div style={filterWrapperStyle}>
          <select
            value={selectedDepartment}
            onChange={(e) => setSelectedDepartment(e.target.value)}
            style={filterStyle}
          >
            <option value="">All Departments</option>
            <option value="1">बांधकाम विभाग</option>
            <option value="2">पाणी पुरवठा</option>
          </select>
        </div>
      )}

      {/* ================= STATUS ================= */}
      {showStatus && (
        <div style={filterWrapperStyle}>
          <select
            value={statusofData}
            onChange={(e) => setstatusofData(e.target.value)}
            style={filterStyle}
          >
            <option value="">All</option>
            <option value="Approved">Approved</option>
            <option value="Pending">Pending</option>
            <option value="Rejected">Rejected</option>
          </select>
        </div>
      )}

      {/* ================= WORK ORDER TYPE ================= */}
      {showWorkOrderType && (
        <div style={filterWrapperStyle}>
          <select
            value={selectedWorkType}
            onChange={(e) => setSelectedWorkType(e.target.value)}
            style={filterStyle}
          >
            <option value="">All Work Types</option>
            <option value="New Work Order">New Work Order</option>
            <option value="Existing Work Order">
              Existing Work Order
            </option>
          </select>
        </div>
      )}

      {showHeadCode && (
        <div style={filterWrapperStyle}>
          <select
            value={selectedHeadCode}
            onChange={(e) => setSelectedHeadCode(e.target.value)}
            style={filterStyle}
          >
            <option value="">Select Head Code</option>

            {headCodeOptions.map((headCode, index) => (
              <option key={index} value={headCode}>
                {headCode}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* ================= DISTRICT ================= */}
      {showDistrict && UserRole === "State" && (
        <div style={filterWrapperStyle}>
          {/* Trigger */}
          <div
            onClick={() => setOpenDistrict(!openDistrict)}
            style={{
              ...filterStyle,
              cursor: "pointer",
            }}
          >
            {SelectedDistrict?.length > 0
              ? SelectedDistrict.join(", ")
              : "Select District"}
          </div>

          {/* Dropdown */}
          {openDistrict && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                width: "150px",
                background: "#fff",
                border: "1px solid #ccc",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                zIndex: 1000,
                fontSize: "13px",
              }}
            >
              {/* All Districts */}
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "6px 8px",
                  borderBottom: "1px solid #eee",
                  cursor: "pointer",
                }}
              >
                <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={toggleAllDistricts}
                  style={{ marginRight: "6px" }}
                />

                All Districts
              </label>

              {/* District List */}
              <div
                style={{
                  maxHeight: "150px",
                  overflowY: "auto",
                }}
              >
                {allDistricts.map((district, index) => (
                  <label
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "6px 8px",
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={SelectedDistrict.includes(district)}
                      onChange={() =>
                        handleDistrictToggle(district)
                      }
                      onClick={(e) => e.stopPropagation()}
                      style={{ marginRight: "6px" }}
                    />

                    {district}
                  </label>
                ))}
              </div>

              {/* OK */}
              <div
                style={{
                  borderTop: "1px solid #eee",
                  padding: "6px",
                  textAlign: "right",
                }}
              >
                <button
                  onClick={() => setOpenDistrict(false)}
                  style={{
                    padding: "4px 10px",
                    fontSize: "12px",
                    borderRadius: "6px",
                    border: "none",
                    background: "#0d6efd",
                    color: "#fff",
                    cursor: "pointer",
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          )}
        </div>
      )}


      {/* ================= TALUKA ================= */}
      {/* {showTaluka && (
        <div style={filterWrapperStyle}>
          <select
            value={SelectedTaluka}
            onChange={(e) => setSelectedTaluka(e.target.value)}
            style={filterStyle}
          >
            <option value="">Select Taluka</option>

            {TalukasofDistrict?.map((val, index) => {
              const taluka =
                typeof val === "string"
                  ? val
                  : val?.ULBNameMarathi || val?.ulb || val?.Taluka;

              return (
                <option key={index} value={taluka}>
                  {taluka}
                </option>
              );
            })}
          </select>
        </div>
      )} */}

      {/* ================= TALUKA Added for single taluka display only not duplicate ================= */}
      {showTaluka && (
        <div style={filterWrapperStyle}>
          <select
            value={SelectedTaluka}
            onChange={(e) => setSelectedTaluka(e.target.value)}
            style={filterStyle}
          >
            <option value="">Select Taluka</option>

            {uniqueTalukas.map((taluka) => (
              <option key={taluka} value={taluka}>
                {taluka}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* ================= YEAR ================= */}
      {showYear && (
        <div style={filterWrapperStyle}>
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            style={filterStyle}
          >
            <option value="">Select Year</option>

            {yearOptions.map((year, index) => (
              <option key={index} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* ================= SEARCH ================= */}
      {showSearch && (
        <div style={filterWrapperStyle}>
          <img
            src="/Search32.png"
            alt="Search"
            style={{
              position: "absolute",
              top: "50%",
              left: "10px",
              transform: "translateY(-50%)",
              width: "16px",
              opacity: 0.6,
              zIndex: 1,
            }}
          />

          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              ...filterStyle,
              padding: "8px 12px 8px 32px",
              backgroundColor: "#f1f6fc",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default CommonFilters;